import { render, staticRenderFns } from "./cellActivitionCode.vue?vue&type=template&id=c28fabbc&scoped=true&"
import script from "./cellActivitionCode.vue?vue&type=script&lang=js&"
export * from "./cellActivitionCode.vue?vue&type=script&lang=js&"
import style0 from "./cellActivitionCode.vue?vue&type=style&index=0&id=c28fabbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28fabbc",
  null
  
)

export default component.exports